import React, { useState, useEffect } from 'react';
import { Plus, Trash2 } from 'lucide-react';

const PRIMARY      = '#2563EB';
const PRIMARY_DARK = '#1D4ED8';

const BillOfEntryTab = ({ data, masterData, onChange }) => {
    const [billItems, setBillItems] = useState(data || []);
    const shippingAgents = masterData.shippingAgents || [];

    useEffect(() => { setBillItems(data || []); }, [data]);

    const addNewRow = () => {
        const newRow = { BillOfEntryID: null, BillOfEntry: '', BillofEntryDate: new Date().toISOString().split('T')[0], ShippingAgentID: null };
        const updated = [...billItems, newRow];
        setBillItems(updated);
        onChange(updated);
    };

    const deleteRow = (index) => {
        if (window.confirm('Delete this bill of entry?')) {
            const updated = billItems.filter((_, i) => i !== index);
            setBillItems(updated);
            onChange(updated);
        }
    };

    const updateRow = (index, field, value) => {
        const updated = [...billItems];
        updated[index][field] = value;
        setBillItems(updated);
        onChange(updated);
    };

    const cellInput  = `w-full px-2.5 py-2 border border-[#CBD5E1] rounded text-sm outline-none transition-all duration-150 focus:border-[#2563EB] focus:shadow-[0_0_0_3px_rgba(37,99,235,0.1)] font-[inherit]`;
    const cellSelect = `w-full px-2.5 py-2 border border-[#CBD5E1] rounded text-sm outline-none cursor-pointer transition-all duration-150 focus:border-[#2563EB] bg-white font-[inherit]`;

    return (
        <div className="p-5 bg-white rounded-lg flex flex-col h-full">

            {/* Toolbar */}
            <div className="mb-4 flex-shrink-0">
                <button onClick={addNewRow}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-bold text-white border-0 rounded-lg cursor-pointer transition-all duration-150 hover:-translate-y-0.5"
                    style={{ background: `linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%)` }}>
                    <Plus size={15} /> Add Bill of Entry
                </button>
            </div>

            {/* Grid */}
            <div className="flex-1 overflow-auto border border-[#E2E8F0] rounded-lg">
                <table className="w-full border-collapse text-sm min-w-[600px]">
                    <thead className="sticky top-0 z-10"
                        style={{ background: `linear-gradient(135deg, ${PRIMARY} 0%, ${PRIMARY_DARK} 100%)` }}>
                        <tr>
                            {['#', 'Bill of Entry No', 'Date', 'Shipping Agent', 'Actions'].map(h => (
                                <th key={h} className="px-3 py-3 text-left text-[11px] font-bold uppercase tracking-wider text-white border-r border-white/20 last:border-r-0">
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {billItems.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="py-10 text-center text-gray-400 text-sm">
                                    No bill of entry records. Click "Add Bill of Entry" to add.
                                </td>
                            </tr>
                        ) : (
                            billItems.map((row, index) => (
                                <tr key={index}
                                    className="border-b border-gray-100 hover:bg-[#EFF6FF] transition-colors duration-150">
                                    <td className="px-3 py-2.5 w-10 text-center font-bold text-[#2563EB]">{index + 1}</td>
                                    <td className="px-3 py-2.5">
                                        <input type="text" value={row.BillOfEntry || ''}
                                            onChange={e => updateRow(index, 'BillOfEntry', e.target.value)}
                                            placeholder="Bill of Entry No" className={cellInput} />
                                    </td>
                                    <td className="px-3 py-2.5 min-w-[150px]">
                                        <input type="date" value={row.BillofEntryDate || ''}
                                            onChange={e => updateRow(index, 'BillofEntryDate', e.target.value)}
                                            className={cellInput} />
                                    </td>
                                    <td className="px-3 py-2.5 min-w-[200px]">
                                        <select value={row.ShippingAgentID || ''}
                                            onChange={e => updateRow(index, 'ShippingAgentID', parseInt(e.target.value))}
                                            className={cellSelect}>
                                            <option value="">Select Agent</option>
                                            {shippingAgents.map(agent => (
                                                <option key={agent.id} value={agent.id}>{agent.name}</option>
                                            ))}
                                        </select>
                                    </td>
                                    <td className="px-3 py-2.5 w-16 text-center">
                                        <button onClick={() => deleteRow(index)} title="Delete"
                                            className="p-1.5 rounded border-0 cursor-pointer bg-transparent transition-all duration-150"
                                            style={{ color: '#DC2626' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#FEE2E2'; e.currentTarget.style.color = '#B91C1C'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#DC2626'; }}>
                                            <Trash2 size={15} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BillOfEntryTab;